import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=3d0e3b70&scoped=true&"
import script from "./Extensions.vue?vue&type=script&lang=js&"
export * from "./Extensions.vue?vue&type=script&lang=js&"
import style0 from "./Extensions.vue?vue&type=style&index=0&id=3d0e3b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0e3b70",
  null
  
)

export default component.exports